module.exports = __webpack_public_path__ + "img/comment_3_5.91157941.jpg";